import { CovalentBalanceItem } from '@shared/types/frontend';
import { ISpecialFixDecimals, getSpecialFixDecimals } from '@/hooks/utilities/useSpecialFixDecimals';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { toSpecialFixed } from '@/lib/misc/utils';
import { ImageWithFallback } from '../shared/NextImageFallback';
export const getUsdAmount = (item: CovalentBalanceItem) => {
  console.log('item get usd amount', item);
  return item?.amountToUse / item?.formatted_balance * (item?.usd_value || item.quote);
};
export const getEthAmount = (item: CovalentBalanceItem) => {
  return item?.amountToUse / item?.quote_rate;
};
export default function SingleAssetHeader({
  assetItem,
  specialFixDecimals
}: {
  assetItem: CovalentBalanceItem;
  specialFixDecimals: ISpecialFixDecimals[];
}) {
  return <>
      <div className='flex items-center gap-2 relative'>
        {assetItem && <>
            {' '}
            <ImageWithFallback src={assetItem?.logo_url || getNetworkLogo(assetItem?.network)} alt='token-logo' width={32} height={32} className='rounded-full' />
            <ImageWithFallback src={getNetworkLogo(assetItem?.network)} className='w-[16px] h-[16px] top-9 left-6 rounded-full absolute shrink-0' alt='network logo' width={10} height={10} />{' '}
          </>}

        <div>
          <p className='text-primary text-base'>{assetItem?.contract_name}</p>
          <p className='text-genius-cream text-base'>{assetItem?.contract_ticker_symbol}</p>
        </div>
      </div>
      <div className='flex items-center gap-2 mt-4'>
        <p className='text-4xl text-primary'>
          {assetItem ? <>
              {' '}
              {toSpecialFixed(assetItem?.amountToUse, getSpecialFixDecimals(assetItem, specialFixDecimals))?.value}
            </> : <>0</>}
        </p>

        <div className='text-sm'>
          {assetItem ? <>({getUsdAmount(assetItem)?.toFixed(2)} USD)</> : <>(0 USD)</>}
        </div>
      </div>

      {assetItem && <>
          {' '}
          <div className='w-full flex flex-col items-center justify-center mt-4 gap-2'>
            <div className='text-lg text-genius-cream'>
              {toSpecialFixed(assetItem?.formatted_balance, getSpecialFixDecimals(assetItem, specialFixDecimals))?.value}{' '}
              {assetItem?.contract_ticker_symbol} Available
            </div>
            <div className='text-xs text-genius-cream'>({assetItem?.quote?.toFixed(2)} USD)</div>
          </div>
        </>}
    </>;
}